import { Ride } from '@geovelo-frontends/commons';
import { Box, ButtonBase, Skeleton } from '@mui/material';
import { navigate } from 'gatsby';
import React from 'react';
import { useTranslation } from 'react-i18next';

function Photo({
  isOwner,
  ride,
  onPhotosDialogOpen,
}: {
  isOwner: boolean;
  onPhotosDialogOpen: () => void;
  ride: Ride | undefined;
}): React.JSX.Element {
  const {
    i18n: { language: currentLanguage },
  } = useTranslation();
  const imageUrl = ride && ride.photos[0]?.url;

  return (
    <>
      {(!ride || imageUrl) && (
        <Box sx={{ aspectRatio: 16 / 9 }}>
          {ride ? (
            <Box
              borderRadius={4}
              component={ButtonBase}
              height="100%"
              onClick={() =>
                isOwner
                  ? navigate(`/${currentLanguage}/ride-update/${ride.id}`)
                  : onPhotosDialogOpen()
              }
              sx={{
                backgroundImage: `url(${imageUrl})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
              }}
              width="100%"
            />
          ) : (
            <Skeleton
              height="100%"
              sx={{ aspectRatio: 16 / 9, borderRadius: 4 }}
              variant="rectangular"
              width="100%"
            />
          )}
        </Box>
      )}
    </>
  );
}

export default Photo;
